import React from "react";
import {
  Avatar,
  TextField,
  Button,
  Grid,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Provider from "../../pages/AdminPages/Provider";
import { PhotoCamera } from "@mui/icons-material";
import { useStyle } from "../../pages/AdminPages/styles";
import { ColorButton } from "../../services/helper";

function AdminEditForm({
  open,
  close,
  errors,
  fullName,
  setFullname,
  emailAddress,
  setEmailAddress,
  mobile_number,
  setMobile_Number,
  password,
  setPassword,
  accountStatus,
  profileStatus,
  preview,
  userName,
  setUserName,
  fillAcconutStatus,
  fillProfileStatus,
  handleAccount,
  handleProfile,
  handleImage,
  handleSubmit,
}) {
  const classes = useStyle();

  return (
    <div>
      <Dialog open={open} maxWidth="lg">
        <div>
          <DialogTitle>
            <div className={classes.heading}>Edit Admin</div>
          </DialogTitle>
          <DialogContent>
            <div className={classes.rowStyle}>
              <Avatar
                alt="Photo"
                src={preview}
                sx={{ width: 100, height: 100 }}
              />
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
                fullWidth
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={handleImage}
                />
                <PhotoCamera />
              </IconButton>
            </div>

            <Grid container spacing={1} style={{ marginTop: 5 }}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  onChange={(event) => setFullname(event.target.value)}
                  label="Full Name"
                  value={fullName}
                  variant="outlined"
                  InputProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  required
                  error={!!errors.fullName}
                  helperText={errors.fullName}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  onChange={(event) => setEmailAddress(event.target.value)}
                  label="Email Address"
                  value={emailAddress}
                  variant="outlined"
                  InputProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  required
                  error={!!errors.emailAddress}
                  helperText={errors.emailAddress}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  onChange={(event) => setUserName(event.target.value)}
                  label="User Name"
                  value={userName}
                  variant="outlined"
                  InputProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  required
                  error={!!errors.userName}
                  helperText={errors.userName}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  onChange={(event) => setPassword(event.target.value)}
                  label="Password"
                  value={password}
                  variant="outlined"
                  type="password"
                  InputProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  required
                  error={!!errors.password}
                  helperText={errors.password}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  onChange={(event) => setMobile_Number(event.target.value)}
                  label="Mobile No"
                  variant="outlined"
                  type="number"
                  value={mobile_number}
                  inputProps={{ maxLength: 10 }}
                  InputProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "Poppins, sans-serif" },
                  }}
                  required
                  error={!!errors.mobile_number}
                  helperText={errors.mobile_number}
                />
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{ fontFamily: "Poppins" }}
                  >
                    Account Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={accountStatus}
                    label="Account Status"
                    onChange={handleAccount}
                    sx={{ fontFamily: "Poppins" }}
                    required
                    error={!!errors?.accountStatus}
                    helperText={errors?.accountStatus}
                  >
                    {/* <MenuItem value={"Choose State..."}>Choose Status...</MenuItem> */}
                    {fillAcconutStatus()}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{ fontFamily: "Poppins" }}
                  >
                    Profile Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={profileStatus}
                    label="Profile Status"
                    onChange={handleProfile}
                    sx={{ fontFamily: "Poppins" }}
                    required
                    error={!!errors?.profileStatus}
                    helperText={errors?.profileStatus}
                  >
                    {/* <MenuItem value={"Choose State..."}>Choose Status...</MenuItem> */}
                    {fillProfileStatus()}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <ColorButton onClick={handleSubmit} fullWidth variant="contained">
              Submit
            </ColorButton>

            <ColorButton
              onClick={() => close(false)}
              fullWidth
              variant="contained"
            >
              Close
            </ColorButton>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

export default AdminEditForm;
